import React from "react";

export default function Loading({ message = "Caricamento in corso..." }) {
	return (
		<section className="section is-medium">
			<div className="loading-container has-text-centered mt-5">
				<div className="loader-wrapper">
					<div className="button is-loading is-large is-info" style={{ border: "none", background: "none" }}></div>
				</div>
				{message && <p className="has-text-weight-bold is-size-4">{message}</p>}
			</div>
		</section>
	);
}
